import { drawerWidth, collapsedDrawerWidth } from './styles'

export const getSidebarLayoutWidth = (
  theme,
  { isDesktopNav, isCollapsibleSidebar, isNavCollapsed },
) => {
  if (isDesktopNav || isCollapsibleSidebar) {
    return isNavCollapsed ? collapsedDrawerWidth(theme) : drawerWidth
  }

  return 0
}

export const shouldShowNavLabels = ({
  isDesktopNav,
  isMobileNav,
  isNavCollapsed,
}) => isDesktopNav || isMobileNav || !isNavCollapsed
